import * as Yup from 'yup';

import i18n from '@/i18n';

export const createReleaseScheme = Yup.object().shape({
  version: Yup.string().required(i18n.t('playerReleaseVersionRequired', { ns: 'common' })),
  url: Yup.string().required(i18n.t('playerReleaseUrlRequired', { ns: 'common' }))
});

export const updateReleaseScheme = Yup.object().shape({
  version: Yup.string().required(i18n.t('playerReleaseVersionRequired', { ns: 'common' })),
  url: Yup.string().required(i18n.t('playerReleaseUrlRequired', { ns: 'common' }))
});
